//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['event'],
  mounted() {},
  methods: {
    getImgUrl(icon) {
      return require('~/assets/stats/'+icon+'.png')
    }
  }
}
